import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { NewsletterForm } from '@dreamstack/feature-components/src/newsletter/NewsletterForm'
import { cn } from '@dreamstack/util/src/cn'
import React from 'react'

const FullWidthBackgroundContainerExtraMargins: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ className, ...rest }) => (
  <div
    className={cn(
      'bg-accentroGray-full z-[-1] w-[100vw] absolute left-1/2 right-1/2 ml-[-50vw] mr-[-50vw]',
      'h-[calc(100% + 96px)] top-[-48px] bottom-[-48px]',
      'md:top-[-96px] md:bottom-[-96px] md:h-[calc(100% + 192px)]',
      'lg:top-[-128px] lg:bottom-[-128px] lg:h-[calc(100% + 256px)]',
      className
    )}
    {...rest}
  />
)

const NewsletterWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => (
  <div
    className={cn(
      'bg-accentroGray-full text-accentroWhite-full relative',
      className
    )}
    {...rest}
  />
)

const Spacing: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => (
  <div
    className={cn(
      'mt-[112px] mb-[112px]',
      'md:mt-[192px] md:mb-[192px]',
      'lg:mt-[224px] lg:mb-[224px]',
      className
    )}
    {...rest}
  />
)

export const NewsletterCustom: React.FC = () => {
  return (
    <NewsletterWrapper>
      <Spacing>
        <FullWidthBackgroundContainerExtraMargins />
        <GridWithGaps>
          <NewsletterForm />
        </GridWithGaps>
      </Spacing>
    </NewsletterWrapper>
  )
}
